import TestSelectors from '@racemap/utilities/consts/test_selectors';
import type { MenuProps } from 'antd';
import { Link } from 'react-router-dom';
import { useCurrentUser } from 'src/lib/customHooks/useCurrentUser';

const ITEMS = [
  {
    path: '/admin/trackers',
    testId: TestSelectors.admin.nav.sections.trackers,
    label: 'Management',
  },
  {
    path: '/admin/message-templates',
    testId: TestSelectors.admin.nav.sections.messageTemplates,
    label: 'Message Templates',
  },
  {
    path: '/admin/sim-cards',
    testId: TestSelectors.admin.nav.sections.sims,
    label: 'SIM Cards',
  },
];

export const useTrackersMenuItems = (): NonNullable<MenuProps['items']> => {
  const currentUser = useCurrentUser();

  if (currentUser == null) return [];

  return ITEMS.map(({ path, testId, label }) => ({
    key: path,
    label: (
      <Link to={path} id={testId.toString()}>
        {label}
      </Link>
    ),
  }));
};
